




import React from 'react';
import Header from './components/Header';
import Home from './pages/Home';
import Footer from './components/Footer';
import Cart from './components/Cart';
import { Provider } from 'react-redux';
import store from './store/store';
import Favorite from './components/Favorite';



function App() {
  return (
    <div>
     
     <Provider store={store}>
      <Header></Header>
      <Home></Home>
      <Footer></Footer>
      <Cart></Cart>
      <Favorite></Favorite>
      </Provider>
    
          
    </div>
  );
}

export default App;
